import { useMemo } from 'react';
import { isLowPower } from '@artica/constants';
import {
  CubeCamera,
  WebGLCubeRenderTarget,
  LinearMipmapLinearFilter,
} from 'three';

export default function useMirror(
  near = 0.1,
  far = 100,
  initialPosition = [0, 0, 0],
  defaultTarget,
) {
  const cubeRenderTarget = useMemo(() => new WebGLCubeRenderTarget(isLowPower ? 256 : 512, {
    generateMipmaps: true,
    minFilter: LinearMipmapLinearFilter,
  }), []);
  
  const renderTarget = defaultTarget || cubeRenderTarget;

  return useMemo(() => {
    const cam = new CubeCamera(near, far, renderTarget);
    cam.position.set(...initialPosition);
    cam.renderTarget = renderTarget;
    return cam;
  }, [
    near,
    far,
    renderTarget,
  ]);
};